module.exports = __webpack_public_path__ + "static/media/schoolfood.3f81e573.jpg";